import { render, staticRenderFns } from "./BROSADCorrectionReason.vue?vue&type=template&id=7d18b294&scoped=true"
import script from "./BROSADCorrectionReason.vue?vue&type=script&lang=js"
export * from "./BROSADCorrectionReason.vue?vue&type=script&lang=js"
import style0 from "./BROSADCorrectionReason.vue?vue&type=style&index=0&id=7d18b294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d18b294",
  null
  
)

export default component.exports